import { EChartsOption } from 'echarts';
import { ChartOptionsArgsT } from 'helpers/eChartHelpers';
import { capitalizeAndKeepTheRest } from 'helpers/helpers';

export const removePaginationFromLegend = () => ({
    pageIconSize: 0,
    pageFormatter() {
        return '';
    },
});

export const getLegendWidth = (graphWidth: number) => {
    if (graphWidth < 300) {
        return 50;
    }
    if (graphWidth > 300 && graphWidth < 600) {
        return 100;
    }
    if (graphWidth > 600 && graphWidth < 900) {
        return 150;
    }
    return 200;
};

/**
 * Format the eCharts legend object to be displayed in the chart.
 */
export const getChartLegendSettings = ({
    isExportModeActivated,
    showLegend,
    showLegendOnRightSide,
    treeValueTranslations,
    width,
}: Pick<
    ChartOptionsArgsT,
    'showLegend' | 'showLegendOnRightSide' | 'treeValueTranslations'
> & {
    isExportModeActivated: boolean;
    width: number;
}): EChartsOption['legend'] => {
    const rightSideLegendParams: EChartsOption['legend'] = {
        orient: 'vertical',
        right: 2,
        left: 'auto',
        top: 'center',
        tooltip: {
            show: true,
            position: 'bottom',
        },
        textStyle: {
            overflow: 'truncate',
            lineHeight: 16,
            width: getLegendWidth(width),
        },
    };
    // we need to set the default value, because eCharts won't revert automatically to the default if we switch back from right side
    const baseLegendParams: EChartsOption['legend'] = {
        orient: 'horizontal',
        left: 'center',
        right: 'auto',
        top: 'auto',
        show: showLegend,
        itemWidth: 14,
        type: 'scroll',
        ...(isExportModeActivated ? removePaginationFromLegend() : {}),
        formatter(name: string) {
            return treeValueTranslations && treeValueTranslations[name]
                ? capitalizeAndKeepTheRest(treeValueTranslations[name])
                : capitalizeAndKeepTheRest(name);
        },
    };
    return showLegendOnRightSide
        ? { ...baseLegendParams, ...rightSideLegendParams }
        : baseLegendParams;
};
